import { Link } from 'react-router-dom';

const NAV_LINKS = [
  { to: '/admin/products',            label: 'Productos',              color: '#E4405F' },
  { to: '/admin/orders',              label: 'Pedidos',                color: '#E4405F' },
  { to: '/admin/artists',             label: 'Artistas',               color: '#7c3aed' },
  { to: '/admin/artist-applications', label: 'Solicitudes de artista', color: '#7c3aed' },
  { to: '/admin/artist-metrics',      label: 'Métricas',               color: '#7c3aed' },
  { to: '/admin/customers',           label: 'Clientes',               color: '#2ca9e1' },
  { to: '/admin/payments',            label: 'Pagos parciales',        color: '#2ca9e1' },
  { to: '/admin/allies',              label: 'Aliados',                color: '#f59e0b' },
  { to: '/admin/feedback',            label: 'Feedback de usabilidad', color: '#0d9488' },
  { to: '/admin/kiosk-loop',          label: 'Video loop del kiosco',  color: '#ff007a' },
  { to: '/admin/ttf-pieces',          label: 'Pedidos Taipei Toy Festival', color: '#ff007a' },
  { to: '/admin/ttf-metrics',         label: 'Métricas Taipei Toy Festival', color: '#ff007a' },
];

// Clarity has no embeddable dashboard/API for heatmaps or session replay
// (docs/ui:ux_feature.md §2.5) — this just links out to the hosted project
// dashboard. Hidden entirely when no project is configured (see src/lib/clarity.js).
const clarityProjectId = process.env.REACT_APP_CLARITY_PROJECT_ID;
const CLARITY_LINK = clarityProjectId
  ? { href: `https://clarity.microsoft.com/projects/view/${clarityProjectId}/dashboard`, label: 'UX Insights (Clarity)', color: '#0d9488' }
  : null;

const linkStyle = (color) => ({
  padding: '0.6rem 1.25rem',
  background: 'white',
  color,
  border: `1.5px solid ${color}`,
  borderRadius: '8px',
  textDecoration: 'none',
  fontWeight: '600',
  fontSize: '0.9rem',
});

const AdminDashboard = () => (
  <div className="container" style={{ padding: '2rem 0 4rem' }}>
    <h1 style={{ fontFamily: "'Gambado Sans', sans-serif", fontSize: '1.75rem', color: '#333', marginBottom: '2rem' }}>
      Panel de Administración
    </h1>
    <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
      {NAV_LINKS.map(({ to, label, color }) => (
        <Link key={to} to={to} style={linkStyle(color)}>
          {label} →
        </Link>
      ))}
      {CLARITY_LINK && (
        <a
          href={CLARITY_LINK.href}
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle(CLARITY_LINK.color)}
        >
          {CLARITY_LINK.label} ↗
        </a>
      )}
    </div>
  </div>
);

export default AdminDashboard;
